import {
  FiCheckCircle,
  FiXCircle,
  FiClock,
  FiCalendar,
  FiCoffee,
} from "react-icons/fi";

const icons = {
  Present: FiCheckCircle,
  Absent: FiXCircle,
  "On Leave": FiCalendar,
  Late: FiClock,
  "Worked time": FiCoffee,
};

const colors = {
  Present: "bg-green-100 text-green-600",
  Absent: "bg-red-100 text-red-600",
  "On Leave": "bg-blue-100 text-blue-600",
  Late: "bg-orange-100 text-orange-600",
  "Worked time": "bg-violet-100 text-violet-600",
};

export default function AttendanceStats({ title, count, caption }) {
  const Icon = icons[title] || FiClock;
  const colorClass = colors[title] || "bg-gray-100 text-gray-600";

  return (
    <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
      <div className="flex items-center justify-between gap-4">
        <div>
          <p className="text-sm text-gray-500">{title}</p>
          <h2 className="mt-2 text-3xl font-bold text-gray-900">
            {count ?? 0}
          </h2>
          {caption ? (
            <p className="mt-1 text-xs text-gray-400">{caption}</p>
          ) : null}
        </div>
        <div
          className={`flex h-14 w-14 items-center justify-center rounded-2xl ${colorClass}`}
        >
          <Icon size={24} />
        </div>
      </div>
    </div>
  );
}
